var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline text-nowrap"},[(_vm.currency)?[_vm._v("₱ ")]:_vm._e(),_vm._v(_vm._s(_vm.input_value.toLocaleString('en-US',{ minimumFractionDigits: _vm.decimal }))+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }